"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNotificationCountState = void 0;
const frontend_infra_auth_1 = require("@forto-dev/frontend-infra-auth");
const notification_center_models_1 = require("@forto-dev/notification-center-models");
const react_1 = require("react");
const useSocket_1 = require("../../../hooks/useSocket");
const getNotificationCount_1 = require("../api/getNotificationCount");
const NOTIFICATION_WIDGET_COUNT_SOCKET_NAMESPACE = '/notification-center.notification-count';
const useNotificationCountState = (app) => {
    const { state: { user }, } = (0, frontend_infra_auth_1.useAuth)();
    const [countData, setCountData] = (0, react_1.useState)();
    const { data } = (0, getNotificationCount_1.useNotificationCount)();
    const { createDomainEventsListeners, initializeSocket, disconnectSocket } = (0, useSocket_1.useSocket)();
    const onNotificationCountUpdate = (newCountData) => {
        setCountData(newCountData);
    };
    (0, react_1.useEffect)(() => {
        setCountData(data);
    }, [data]);
    (0, react_1.useEffect)(() => {
        initializeSocket(app, NOTIFICATION_WIDGET_COUNT_SOCKET_NAMESPACE, {
            userId: user?._id,
        });
        createDomainEventsListeners([
            {
                eventType: notification_center_models_1.WS_PUBLIC_NOTIFICATION_COUNT_UPDATED,
                callback: (response) => onNotificationCountUpdate(response.payload),
            },
        ]);
        return () => {
            disconnectSocket();
        };
    }, []);
    return {
        countData,
    };
};
exports.useNotificationCountState = useNotificationCountState;
//# sourceMappingURL=useNotificationCountState.js.map